import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import moment from 'moment';
import Loader from "../CommonLoader";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from 'react-select';

import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorGWT from "./ErrorGWT";
import { Helmet } from 'react-helmet';
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { Commonfun } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import ApexCharts from "react-apexcharts";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import CommonAlert from "../../../Commonalert/commonalert";
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import { Breadcrumbs, Typography } from "@mui/material";
import useMediaQuery from '@mui/material/useMediaQuery';
import GetAppIcon from '@mui/icons-material/GetApp';
import { Link } from "react-router-dom";
import AverageRanksvg from "../Asset/esocardicon/Branded_NonBranded/AverageRank.svg"
import AvgCTRsvg from "../Asset/esocardicon/Branded_NonBranded/AvgCTR.svg"
import TotalClickssvg from "../Asset/esocardicon/Branded_NonBranded/TotalClicks.svg"
import TotalImpressionssvg from "../Asset/esocardicon/Branded_NonBranded/TotalImpressions.svg"
import DatagridComp from "../DatagridComp";
import PdfandCsv from "../PdfandCsv";
import Commoncard from "../Commoncard";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";


const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
  <input
    ref={ref}
    value={value}
    onClick={onClick}
    title="Select a Start Date"
    readOnly
    style={{ cursor: "pointer" }}
  />
));
const CustomInput1 = React.forwardRef(({ value, onClick }, ref) => (
  <input
    ref={ref}
    value={value}
    onClick={onClick}
    title="Select a End Date"
    readOnly
    style={{ cursor: "pointer" }}
  />
));
const GoogleConsole = () => {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [buttnval, setMenubutval] = useState('brand')
  const SevenDaysBefore = moment().subtract(7, 'd').toDate();
  const [startDate, setStartDate] = useState(SevenDaysBefore);
  const [EndDate, SetEndDate] = useState(new Date());
  const [cardData, setCardData] = useState([]);
  const rows = cardData;
  const [loading, setLoading] = useState(false);
  const [ShowMainAlert, SetShowMainAlert] = useState(true)
  const [TableErrorMessage, SetTableErrorMessage] = useState('')
  const [autoheightval, SetAutoheightval] = useState(true)
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [brandType, setBrandType] = useState({ label: 'impressions', value: 'Impressions' });
  const isMobile = useMediaQuery('(max-width:600px)');
  const isTablet = useMediaQuery('(min-width:600px) and (max-width:900px)');
  const [freesiteaudit, setfreesiteaudit] = useState({ status: false, error: "" });
  const [freesiteaudit1, setfreesiteaudit1] = useState({ status: false, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);


  const navigate = useNavigate();
  function roundToTwoDecimalPlaces(number) {
    return parseFloat(number.toFixed(2));
  }

  const apihandleClose = () => {
    setapiOpen(false);
  };


  const columns = [
    {
      field: "keys",
      headerName: "Search Query/Keyword",
      minWidth: 300,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
      description: "The search terms or keywords through which the user has reached your website.",
      renderCell: (cardData) => {



      }
    },
    {
      field: "impressions",
      headerName: "Impressions",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
      description: "It is counted each time your ad or webpage link is shown on a search result page.",

    },
    {
      field: "clicks",
      headerName: "Clicks",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableClickEventBubbling: true,
      description: "Every click by the viewer on the website available on the organic search results is counted as a click.",

    },
    {
      field: "ctr",
      headerName: "CTR %",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      sortable: false,
      description: "It means the number of clicks that your website receives divided by the number of impressions of your website (clicks/impression).",
      renderCell: (cardData) => {
        var RoundedVal = 0;
        RoundedVal = roundToTwoDecimalPlaces(cardData.row.ctr)
        return (
          <>{RoundedVal}%</>
        )
      }
    },
    {
      field: "position",
      headerName: "Average Position",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      sortable: false,
      description: "Average position (ranking) of the keywords that were added to the campaign through campaign settings.",

      renderCell: (cardData) => {

        var RoundedVal = 0;
        RoundedVal = roundToTwoDecimalPlaces(cardData.row.position)
        return (
          <>{RoundedVal}</>
        )
      }

    },
  ];

  const menuChange = (e) => {
    setMenubutval(e.target.id)
    GetAPIData(e.target.id)
    faqdatafun(e.target.id)
  }


  const GetAPIData = async (type = '') => {
    setLoading(true);
    setTableLoading(true);
    setCardData("")
    SetShowMainAlert(false)
    SetTableErrorMessage('')
    SetTotalImpressions(0)
    SetTotalClicks(0)
    SetAverageCTR(0)
    SetAverageRank(0)
    var Passstart = moment(startDate).format('YYYY-MM-DD')
    var Passend = moment(EndDate).format('YYYY-MM-DD')
    try {

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}googleanalytics/v2/brandvsnonbrand_table/?user_domain_id=${esodata.domaindata.value.header_selected}&start_date=${Passstart}&end_date=${Passend}&keyword_type=${type}`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });

      if (datavalue?.data?.queries) {
        SetTotalImpressions(datavalue.data.queries.impressions)
        SetTotalClicks(datavalue.data.queries.clicks)
        SetAverageCTR(datavalue.data.queries.ctr + '%')
        SetAverageRank(datavalue.data.queries.rank)
      }

      if (datavalue.data.queries) {
        if (datavalue.data.queries.keywords) {
          if (datavalue.data.queries.keywords.length > 0) {
            const newData = datavalue.data.queries.keywords.map((obj, index) => {
              return { ...obj, sid: index + 1 };
            });
            setCardData(newData);
            SetAutoheightval(false)
          }
          else {
            var ErrorMessage;
            if (type == 'brand') {
              SetAutoheightval(true)
              setCardData("");
            }
            else if (type == 'non-brand') {
              ErrorMessage = 'Non-branded keywords not available for this domain'
            }
            SetTableErrorMessage(ErrorMessage)
            SetAutoheightval(true)
          }
        }
      }
      if (datavalue.data.status_code) {
        SetShowMainAlert(true)
      }
    } catch (err) {
      if (err.response) {
        if (err.response.data) {
          SetTableErrorMessage(err.response.data.error)
        }
        else {
          SetTableErrorMessage('')
        }
      }
      else {
        SetTableErrorMessage('')
      }
    }
    setTableLoading(false);
    setLoading(false);
  }

  const [BrandPercentage, SetBrandPercentage] = useState(0)
  const [BrandLabel, SetBrandLabel] = useState('')
  const [NonBrandPercentage, SetNonBrandPercentage] = useState(0)
  const [NonBrandLabel, SetNonBrandLabel] = useState('')
  const [ChartType, SetChartType] = useState('impressions')
  const [TotalImpressions, SetTotalImpressions] = useState(0)
  const [TotalClicks, SetTotalClicks] = useState(0)
  const [AverageCTR, SetAverageCTR] = useState(0)
  const [AverageRank, SetAverageRank] = useState(0)

  const GetGraphdata = async (type = '') => {
    setLoading(true)
    SetBrandPercentage(0)
    SetNonBrandPercentage(0)
    var Passstart = moment(startDate).format('YYYY-MM-DD')
    var Passend = moment(EndDate).format('YYYY-MM-DD')
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}googleanalytics/v2/brandvsnonbrand_graph/?user_domain_id=${esodata.domaindata.value.header_selected}&start_date=${Passstart}&end_date=${Passend}&chart_option=${type}`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      setLoading(false)
      if (datavalue?.data) {
        if (datavalue?.data?.chart_data) {
          SetChartType(datavalue.data.chart_data.chart_option)
          SetBrandPercentage(datavalue.data.chart_data.brand_percentage)
          SetNonBrandPercentage(datavalue.data.chart_data.non_brand_percentage)
          SetBrandLabel('Branded-' + datavalue.data.chart_data.brand_percentage + '%' + ' (' + datavalue.data.chart_data.brand_value + ')')
          SetNonBrandLabel('Non Branded-' + datavalue.data.chart_data.non_brand_percentage + '%' + ' (' + datavalue.data.chart_data.non_brand_value + ')')
        }
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  useEffect(() => {
    GetAPIData('brand')
    GetGraphdata('impressions')
    faqdatafun()
  }, [])

  const SubmitData = () => {
    GetAPIData(buttnval)
    GetGraphdata(ChartType)
  }


  const CheckPieRender = (brandpercentage, nonbrandpercentage) => {

    if (brandpercentage == 0 && nonbrandpercentage == 0) {
      return false
    }
    else {
      return true
    }



  }

  const SetChartTypeTrigger = (value) => {
    SetChartType(value.value)
    GetGraphdata(value.value)
    setBrandType(value);

  }
  const pdfdown = async () => {
    if (buttnval == "brand")
      var keytype = "brand";
    else if (buttnval == "non-brand")
      var keytype = "non-brand";
    var Passstart = moment(startDate).format('YYYY-MM-DD')
    var Passend = moment(EndDate).format('YYYY-MM-DD')
    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}googleanalytics/v2/brandvsnonbrand_table/?user_domain_id=${esodata.domaindata.value.header_selected}&start_date=${Passstart}&end_date=${Passend}&keyword_type=${keytype}&chart_option=${ChartType}&formats=pdf`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        var filedata = await Commonfun("Branded vs Non Branded", "pdf", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);

  }
  const csvdown = async () => {
    var Passstart = moment(startDate).format('YYYY-MM-DD')
    var Passend = moment(EndDate).format('YYYY-MM-DD')
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}googleanalytics/v2/brandvsnonbrand_table/?user_domain_id=${esodata.domaindata.value.header_selected}&start_date=${Passstart}&end_date=${Passend}&keyword_type=brand&chart_option=${ChartType}&formats=csv`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("Branded vs Non Branded", "csv", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);
  }

  const faqdatafun = async (menubutval = "") => {
    if (menubutval == "brand" || menubutval == "")
      var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=37`
    else if (menubutval == "non-brand")
      var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=38`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };

  const chartOptions = {
    chart: {
      type: "donut",
      height: 350,

    },
    labels: [BrandLabel, NonBrandLabel],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: "100%",
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    legend: {
      position: isMobile || isTablet ? "bottom" : "right",
      horizontalAlign: "center",
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
        },
      },
    },
    title: {
      text: "Brand Vs Non-Brand",
      align: "center",
      style: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#263238",
      },
    },
  };

  const chartSeries = [BrandPercentage, NonBrandPercentage];

  const freeAudit = async () => {

    if (buttnval === "brand") {
      const check = await Utils("branded_keywords", ApiToken);
      setfreesiteaudit(check);
      setfreesiteaudit1({ status: false, error: "" });
    } else if (buttnval === "non-brand") {
      const check1 = await Utils("non_branded_keywords", ApiToken);
      setfreesiteaudit1(check1);
      setfreesiteaudit({ status: false, error: "" });

    }
  }

  useEffect(() => {
    freeAudit();
  }, [buttnval])

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const menuItemStyle = {
    padding: "10px 16px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    backgroundColor: "#fff",
    transition: "background 0.2s",
  };

  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }


  const cardDatas = [
    { title: "Total Impressions", value: TotalImpressions, iconSrc: TotalImpressionssvg, altText: "Total Impressions", iconColor: 1, bgColor: 1 },
    { title: "Total Clicks", value: TotalClicks, iconSrc: TotalClickssvg, altText: "Total Clicks", iconColor: 2, bgColor: 2 },
    { title: "Avg CTR", value: AverageCTR, iconSrc: AvgCTRsvg, altText: "Avg CTR", iconColor: 3, bgColor: 3 },
    { title: "Average Rank", value: AverageRank, iconSrc: AverageRanksvg, altText: "Average Rank", iconColor: 4, bgColor: 4 }
  ];


  return (
    <div className={`over_all_container brand_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`} >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Branded VS Non-Branded</title>
      </Helmet>
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      {
        loading === true ? <Loader /> : null
      }

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Branded VS Non-Branded
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Google Analytics' },
                      { title: 'Brand Vs Non Brand', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>



      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-tab">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={5}>
            </Grid>
            <Grid item xs={12} md={7}>
              <div className="drop_down_button" >
                {buttnval === "brand" && freesiteaudit.status && <div className="wrap_trans_back">
                  <div className="daterangepicker_wrap drop_down_button">
                    <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} placeholderText="Start Date"
                      customInput={<CustomInput />} />
                    <DatePicker selected={EndDate} onChange={(date) => SetEndDate(date)} placeholderText="End Date" customInput={<CustomInput1 />} />
                    <button className="btn_dashboard" onClick={() => { SubmitData() }}>Submit</button>
                    <Select
                      value={brandType}
                      options={[
                        { value: 'impressions', label: 'Impressions' },
                        { value: 'clicks', label: 'Clicks' },
                        { value: 'ctr', label: 'CTR' },
                        { value: 'rank', label: 'Rank' },
                        { value: 'ranked-terms', label: 'Ranked terms' },
                        { value: '1st-position', label: '1st Position' },
                        { value: '1st-page', label: '1st Page' }
                      ]}
                      placeholder="Select..."
                      onChange={(e) => { SetChartTypeTrigger(e) }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                      classNamePrefix="common-domain-dropdown_color"
                    />
                  </div>
                </div>}

                {buttnval === "non-brand" && freesiteaudit1.status && <div className="wrap_trans_back">
                  <div className="daterangepicker_wrap drop_down_button" >
                    <DatePicker selected={startDate} onChange={(date) => setStartDate(date)}  placeholderText="Start Date"/>
                    <DatePicker selected={EndDate} onChange={(date) => SetEndDate(date)}  placeholderText="End Date" />
                    <button className="btn_dashboard" onClick={() => { SubmitData() }}>Submit</button>
                    <Select
                      value={brandType}
                      options={[
                        { value: 'impressions', label: 'Impressions' },
                        { value: 'clicks', label: 'Clicks' },
                        { value: 'ctr', label: 'CTR' },
                        { value: 'rank', label: 'Rank' },
                        { value: 'ranked-terms', label: 'Ranked terms' },
                        { value: '1st-position', label: '1st Position' },
                        { value: '1st-page', label: '1st Page' }
                      ]}
                      placeholder="Select..."
                      onChange={(e) => { SetChartTypeTrigger(e) }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                      classNamePrefix="common-domain-dropdown_color"
                    />
                  </div>
                </div>}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "30px", marginBottom: "20px" }} >
        <Box style={{ background: "#fff", padding: "20px 0px 20px 0px" }} className="grid_table_shodow">
          <Grid container style={{ display: "flex", alignItems: "center" }} >
            <Grid item xs={12} md={12}>
            </Grid>
          </Grid>
        </Box>
      </Container> */}
      <div className="">
        {ShowMainAlert === false && CheckPieRender(BrandPercentage, NonBrandPercentage) && freesiteaudit.status && buttnval === "brand" ? (
          <div className="pie-chart-outer">
            <div className="pie-chart-inner">
              <ApexCharts options={chartOptions} series={chartSeries} type="donut" height={350} />
            </div>
          </div>
        ) : null}

        {ShowMainAlert === false && CheckPieRender(BrandPercentage, NonBrandPercentage) && freesiteaudit1.status && buttnval === "non-brand" ? (
          <div className="pie-chart-outer">
            <div className="pie-chart-inner">
              <ApexCharts options={chartOptions} series={chartSeries} type="donut" height={350} />
            </div>
          </div>
        ) : null}
      </div>


      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-tab">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="trendy-tabs-wrapper">
                <div className="trendy-tab-container">
                  <button type="button" id='brand' onClick={e => menuChange(e)}
                    className={`trendy-tab ${buttnval === "brand" ? "active" : ""}`}  >Branded Keyword</button>
                  <button type="button" id='non-brand' onClick={e => menuChange(e)}
                    className={`trendy-tab ${buttnval === "non-brand" ? "active" : ""}`}  >Non Branded Keyword</button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* <div style={{ marginTop: "15px" }} className="googleanaclass">
        <button type="button" id='brand' className={`runreportnews  ${buttnval === "brand" ? 'active' : ""}`} onClick={e => menuChange(e)} >Branded Keyword</button>
        <button type="button" id='non-brand' className={`runreportnews  ${buttnval === "non-brand" ? 'active' : ""}`} onClick={e => menuChange(e)} >Non Branded Keyword</button>
      </div> */}

      {/* <Container maxWidth={false} className="dashboard-card-container">
        <Box className="dashboard-box-card">
          <Grid container className="dashboard-card-grid">
            <Grid item xs={12} md={12}> */}
      <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "50px", marginBottom: "40px" }} >
        <Box >
          <Grid container style={{ display: "flex", alignItems: "center" }} >
            <Grid container spacing={3} justifyContent="center">
              {
                ShowMainAlert === false && freesiteaudit.status && buttnval === "brand" ?

                  <>
                    {cardDatas.map((item, index) => (
                      <Grid item xs={12} sm={6} md={3} key={index}>
                        <Commoncard item={item} />
                      </Grid>
                    ))}
                  </> : null
              }
              {
                ShowMainAlert === false && freesiteaudit1.status && buttnval === "non-brand" ?

                  <>
                    {cardDatas.map((item, index) => (
                      <Grid item xs={12} sm={6} md={3} key={index}>
                        <Commoncard item={item} />
                      </Grid>
                    ))}
                  </> : null
              }
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                {
                  (ShowMainAlert === false /*&& cardData.length > 0 */ && freesiteaudit.status && buttnval === "brand") ?
                    <DatagridComp
                      columns={columns}
                      rows={rows}
                      autoheightval={autoheightval}
                      datagridval={2}
                      columnFreezeWidth={[0]}
                      tableLoading={tableLoading}
                      customFilter={false}
                      DownloadShowFile={true}
                      DownloadShowPDF={1}
                      DownloadShowCSV={2}
                    /> : null
                }

                {
                  (ShowMainAlert === false /*&& cardData.length > 0 */ && freesiteaudit1.status && buttnval === "non-brand") ?
                    <DatagridComp
                      columns={columns}
                      rows={rows}
                      autoheightval={autoheightval}
                      datagridval={2}
                      columnFreezeWidth={[0]}
                      tableLoading={tableLoading}
                      customFilter={false}
                      DownloadShowFile={true}
                      DownloadShowPDF={1}
                      DownloadShowCSV={2}
                    /> : null
                }

                {
                  ShowMainAlert === true && freesiteaudit.status && buttnval === "brand" ?

                    <ErrorGWT /> : null
                }
                {
                  ShowMainAlert === true && freesiteaudit1.status && buttnval === "non-brand" ?

                    <ErrorGWT /> : null
                }

                {
                  !freesiteaudit.status && buttnval === "brand" ? <Freeaudit planStatus={freesiteaudit} /> : null

                }

                {
                  !freesiteaudit1.status && buttnval === "non-brand" ? <Freeaudit planStatus={freesiteaudit1} /> : null

                }
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2025 |
                  <a href="https://www.egrovesys.com/" target="_blank"> <span className="footer-brand"> eGrove System</span></a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}


      {/* <div className="cnt_audit_outer_wrap">
        <div className="top_breadcrumb_menu">
          <CommonBreadCrumb breadcrumbValue={[
            { title: 'Google Analytics' },
            { title: 'Brand Vs Non Brand', activeColor: true }
          ]} />
          <div className="exportpdf_outer">
            <button onClick={handleToggle} className="faq_class exportpdf" title="Frequently Asked Question" >
              <QuestionMarkIcon />
            </button>
            {freesiteaudit.status && buttnval === "brand" &&
              <>
                <PdfandCsv Downloadval={1} isDownloadingcsv={isDownloadingcsv} isDownloading={isDownloading}
                  csvdown={csvdown} pdfdown={pdfdown} />
              </>
            }
            {freesiteaudit1.status && buttnval === "non-brand" &&
              <>
                <PdfandCsv Downloadval={1} isDownloadingcsv={isDownloadingcsv} isDownloading={isDownloading}
                  csvdown={csvdown} pdfdown={pdfdown} />
              </>
            }
          </div>
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
        </div>

        <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <h2 className="heading_font">Branded Vs Non Branded</h2>
          </div>
          {buttnval === "brand" && freesiteaudit.status && <div className="wrap_trans_back">
            <div className="daterangepicker_wrap">
              <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} placeholderText="Start Date"
                customInput={<CustomInput />} />
              <DatePicker selected={EndDate} onChange={(date) => SetEndDate(date)} placeholderText="End Date" customInput={<CustomInput1 />} />
              <button className="runreportnew" onClick={() => { SubmitData() }}>Submit</button>
              <Select
                value={brandType}
                options={[
                  { value: 'impressions', label: 'Impressions' },
                  { value: 'clicks', label: 'Clicks' },
                  { value: 'ctr', label: 'CTR' },
                  { value: 'rank', label: 'Rank' },
                  { value: 'ranked-terms', label: 'Ranked terms' },
                  { value: '1st-position', label: '1st Position' },
                  { value: '1st-page', label: '1st Page' }
                ]}
                placeholder="Select..."
                onChange={(e) => { SetChartTypeTrigger(e) }}
                styles={customDropdownStyles()}
                menuPortalTarget={document.body}
                classNamePrefix="common-domain-dropdown"
              />
            </div>
          </div>}

          {buttnval === "non-brand" && freesiteaudit1.status && <div className="wrap_trans_back">
            <div className="daterangepicker_wrap" >
              <DatePicker className="DataPicker_width" selected={startDate} onChange={(date) => setStartDate(date)} />
              <DatePicker className="DataPicker_width" selected={EndDate} onChange={(date) => SetEndDate(date)} />
              <button className="google_analytics_submit daterangepicker_wrap_submit runreportnew" onClick={() => { SubmitData() }}>Submit</button>
              <Select
                value={brandType}
                options={[
                  { value: 'impressions', label: 'Impressions' },
                  { value: 'clicks', label: 'Clicks' },
                  { value: 'ctr', label: 'CTR' },
                  { value: 'rank', label: 'Rank' },
                  { value: 'ranked-terms', label: 'Ranked terms' },
                  { value: '1st-position', label: '1st Position' },
                  { value: '1st-page', label: '1st Page' }
                ]}
                placeholder="Select..."
                onChange={(e) => { SetChartTypeTrigger(e) }}
                styles={customDropdownStyles()}
                menuPortalTarget={document.body}
                classNamePrefix="common-domain-dropdown"
              />
            </div>
          </div>}
        </div>

        {ShowMainAlert === false && CheckPieRender(BrandPercentage, NonBrandPercentage) && freesiteaudit.status && buttnval === "brand" ? (
          <div className="pie-chart-outer">
            <div className="pie-chart-inner">
              <ApexCharts options={chartOptions} series={chartSeries} type="donut" height={350} />
            </div>
          </div>
        ) : null}

        {ShowMainAlert === false && CheckPieRender(BrandPercentage, NonBrandPercentage) && freesiteaudit1.status && buttnval === "non-brand" ? (
          <div className="pie-chart-outer">
            <div className="pie-chart-inner">
              <ApexCharts options={chartOptions} series={chartSeries} type="donut" height={350} />
            </div>
          </div>
        ) : null}

        <div style={{ marginTop: "15px" }} className="googleanaclass">
          <button type="button" id='brand' className={`runreportnews  ${buttnval === "brand" ? 'active' : ""}`} onClick={e => menuChange(e)} >Branded Keyword</button>
          <button type="button" id='non-brand' className={`runreportnews  ${buttnval === "non-brand" ? 'active' : ""}`} onClick={e => menuChange(e)} >Non Branded Keyword</button>
        </div>

        {
          ShowMainAlert === false && freesiteaudit.status && buttnval === "brand" ?

            <div className="common-card-container">
              {cardDatas.map(({ title, value, iconSrc, altText }) => (
                <Commoncard key={title} title={title} value={value} iconSrc={iconSrc} altText={altText} nonclikable={true} />
              ))}
            </div> : null
        }
        {
          ShowMainAlert === false && freesiteaudit1.status && buttnval === "non-brand" ?

            <div className="common-card-container">
              {cardDatas.map(({ title, value, iconSrc, altText }) => (
                <Commoncard key={title} title={title} value={value} iconSrc={iconSrc} altText={altText} nonclikable={true} />
              ))}
            </div> : null
        }

        {
          (ShowMainAlert === false && freesiteaudit.status && buttnval === "brand") ?
            <DatagridComp
              columns={columns}
              rows={rows}
              autoheightval={autoheightval}
              datagridval={2}
              columnFreezeWidth={[0]}
              tableLoading={tableLoading}
            /> : null
        }

        {
          (ShowMainAlert === false && freesiteaudit1.status && buttnval === "non-brand") ?
            <DatagridComp
              columns={columns}
              rows={rows}
              autoheightval={autoheightval}
              datagridval={2}
              columnFreezeWidth={[0]}
              tableLoading={tableLoading}
            /> : null
        }

        {
          ShowMainAlert === true && freesiteaudit.status && buttnval === "brand" ?

            <ErrorGWT /> : null
        }
        {
          ShowMainAlert === true && freesiteaudit1.status && buttnval === "non-brand" ?

            <ErrorGWT /> : null
        }

        {
          !freesiteaudit.status && buttnval === "brand" ? <Freeaudit planStatus={freesiteaudit} /> : null

        }

        {
          !freesiteaudit1.status && buttnval === "non-brand" ? <Freeaudit planStatus={freesiteaudit1} /> : null

        }

      </div> */}
      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }
    </div>
  )

}
export default GoogleConsole